//@ts-ignore
//@ts-nocheck
import { cast, flow, getEnv, getSnapshot, types } from "mobx-state-tree";
import { ClientRequestStore } from "..";
import {
  generateSplitRequest,
  mapFunctionToRequestType,
} from "../../home-tutoring/request-flow/request-fns";
import BookingStore from "./bookingStore";
import RequestFlowStore from "./requestFlow";
import SearchContextPropType from "./search-context";
import SplitRequestStore from "./splitRequest";

const SpecialityType = types.model("SpecialityType", {
  key: types.string,
  values: types.optional(types.array(types.string), []),
});
const TutorPrices = types.model("TutorPrice", {
  tutorId: types.optional(types.string, ""),
  rate: types.optional(types.number, 0),
});

export const SearchStore:any = types
  .model("SearchStore", {
    oldSearchContextProps: types.optional(SearchContextPropType, {}),
    useRequestDataProps: types.optional(RequestFlowStore, {}),
    splitRequests: types.optional(types.array(SplitRequestStore), []),
    hasSubmitFailed: types.optional(types.boolean, false),
    specialities: types.optional(types.array(SpecialityType), []),
    deniedTutors: types.optional(types.array(types.string), []),
    previousTutors: types.optional(types.array(TutorPrices), []),
    farePerKM: types.optional(types.number, 50),
    distanceThreshold: types.optional(types.number, 5),
    singleCondition: types.optional(types.boolean, true), // used in determining if all tutors have been selected in search-context `hasSelectedAllTutors`,
    displaySelectedTutors: types.optional(types.boolean, false),
    bookingInfo: types.maybe(BookingStore),
    clientRequest: types.optional(ClientRequestStore, {}),
    notifyClient: types.optional(types.boolean, false),
    hasSearch: types.optional(types.boolean, true),
    sthUndefined: types.optional(types.boolean, false)
  })
  .views((self) => {
    return {
      get clientProfileLink() {
        return `/tutors/select/${self.slug}`;
      },
      get isLoggedIn() {
        return self.useRequestDataProps.isLoggedIn;
      },
      get resultsPerPage() {
        return 50;
      },
      get hasRequestData() {
        return Boolean(self.useRequestDataProps.slug);
      },
      get displayAllTutors() {
        return false;
      },
      get workingSplitRequest() {
        return self.splitRequests;
      },
      get isMultipleRequest() {
        return false;
        // return self.splitRequests.length > 1;Todo: revisit this
      },
      get filterStore() {
        return self.useRequestDataProps.filterStore;
      },
      buildInfoUrl(url) {
        return (x) => `${url}${x}/info`;
      },
      getSpeciality(searchSubject) {
        let r = self.specialities.find((o) => o.key === searchSubject);
        return r?.values.toJSON() || [];
      },
      get requestFunction() {
        const getRequestFunction = (a) => {
          /**
           * Determines the relevant function / hook to call which is used to
           * interpret the data of each tutor to be displayed in the search results
           * based on the subject or skill user requested.
           *
           * @returns {Function} It returns a request hook which is passed the data of each
           * tutor to generate details for the search result.
           */

          let requestHook: any = () => {};
          if (self.oldSearchContextProps.isParent) {
            requestHook = mapFunctionToRequestType.ACADEMIC_REQUESTS;
          }
          return a ? (u) => requestHook(u, a) : () => {};
        };
        // Extending each tutor search result with additional properties
        return getRequestFunction(self.oldSearchContextProps);
      },
      get requestData() {
        let currentSplitRequest = getSnapshot(self.splitRequests);
        return {
          ...self.useRequestDataProps.requestData,
          splitRequests:
            self.useRequestDataProps.getScheduleSplit(currentSplitRequest),
          // splitRequests: this.splitRequests.map((o) => getSnapshot(o)),
        };
      },
      get slug() {
        return self.useRequestDataProps.slug;
      },
      get isAdminLogin() {
        return self.useRequestDataProps.isAdminLogin;
      },
      get sendingToClient() {
        return self.useRequestDataProps.sendingToClient;
      },
      get selectedSplits() {
        return self.splitRequests.filter((split) =>
          Boolean(split.selectedTutor),
        );
      },
      generateAmount(value) {
        return Math.round(value);
      },
      generatePaymentInfo() {
        return self.oldSearchContextProps.generatePaymentInfo();
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv(self);
    const onSubmit = flow(function* onFormSubmit(data) {
      try {
        let paymentInfo = self.oldSearchContextProps.generatePaymentInfo();
        const result = yield adapter.onTutorsSelected(
          data,
          paymentInfo,
          self.isAdminLogin,
          self.notifyClient,
        );
        self.hasSubmitFailed = false;
        return result;
      } catch (error) {
        self.hasSubmitFailed = true;
        throw error;
      }
    });
    const saveRequestInfo = flow(function* saveRequestInfo() {
      try {
        let data = self.requestData;
        let paymentInfo = self.generatePaymentInfo();
        const result = yield adapter.onTutorsSelected(
          data,
          paymentInfo,
          self.isAdminLogin,
        );
        return result;
      } catch (error) {
        console.log(error);
        throw error;
      }
    });
    const fetchTutor = flow(function* fetchTutorToAddToSplit(email) {
      return yield adapter.fetchTutorToAddToSplit(self.requestData, email);
    });
    const initializeRequestStore = flow(function* initializeStore(
      requestData, //debugger
      _tutorsData = [],
      specialities = [],
      academicInfo,
    ) {
      let result = requestData;
      let tutorsData = _tutorsData;
      if (!result) {
        let [rData, xData] = yield adapter.initializeRequestData();
        result = rData;
        tutorsData = xData;
      }
      self.useRequestDataProps.mapToStore(result, academicInfo, tutorsData);

      // self.useRequestDataProps.mapToStore(result, undefined, tutorsData);
      self.specialities = cast(specialities);
      let split = requestData.splitRequests || [];
      if (split.length == 0) {
        let { childDetails, teacherKind } = self.requestData;
        split = generateSplitRequest(childDetails, teacherKind);
        // the need to add the tutors to the split request.
      }
      // check if split request does not have days attached to it. if not, update accordingly
      let withoutDays = split.filter((x) => {
        let days = x.lessonDays || [];
        return days.length == 0;
      });
      if (withoutDays.length > 0) {
        if (
          requestData.clientSchedule &&
          Array.isArray(requestData.clientSchedule) &&
          requestData.clientSchedule.length > 0
        ) {
        } else {
          self.useRequestDataProps.scheduleStore.initializeStore(
            split.length,
            getSnapshot(self.useRequestDataProps.lessonScheduleStore),
          );
        }
      }
      if (split.length > 0) {
        // if (
        //   split.length !=
        //   self.useRequestDataProps.scheduleStore.clientSchedule.length
        // ) {
        //   self.useRequestDataProps.scheduleStore.initializeStore(
        //     split.length,
        //     getSnapshot(self.useRequestDataProps.lessonScheduleStore)
        //   );
        // }
        let _split = self.useRequestDataProps.getScheduleSplit(split);
        _split = _split.map((o) => {
          let _tutorData = o.tutorData;
          if (!_tutorData) {
            _tutorData = tutorsData.find((j) => j.userId === o.tutorId);
          }
          return {
            ...o,
            tutorData: _tutorData,
          };
        });
        self.splitRequests = cast(_split);
      } else {
        updateSplitRequests();
      }
      // self.useRequestDataProps.moveToNewScheduleFlow();
    });
    const updateSplitRequests = (key?: string) => {
      let newRequestSplit = self.useRequestDataProps.splitRequests;
      console.log({ split: newRequestSplit.length });
      if (key) {
        self.splitRequests = cast(
          self.splitRequests.map((o, i) => {
            return { ...getSnapshot(o), [key]: newRequestSplit[i][key] };
          }),
        );
      } else {
        self.splitRequests = cast(newRequestSplit);
      }
      // self.oldSearchContextProps.onApplyFilters({})
      // onUpdateFilters({});
    };
    const initializeApplication = flow(function* initializeApp(
      requestData,
      couponCode,
      firstSearch = [],
      tutorsData = [],
      specialities = [],
      farePerKM?: any,
      distanceThreshold?: any,
      academicInfo?: any,
      tutorPrices = [],
      delay = false,
    ) {
      self.previousTutors = cast(tutorPrices);
      yield initializeRequestStore(
        requestData,
        tutorsData,
        specialities,
        academicInfo,
      );
      if (farePerKM && distanceThreshold) {
        self.oldSearchContextProps.setFareData(farePerKM, distanceThreshold);
      }
      if (!delay) {
        yield self.oldSearchContextProps.onCreate(couponCode, firstSearch);
        yield self.oldSearchContextProps.initializeSearchIndex();
      }
    });
    function onUpdateFilters(filterData) {
      self.filterStore.updateData(filterData);
      // update requestForm lessonType filter under the lessonDetail field
      self.useRequestDataProps.lessonScheduleStore.updateFields({
        lessonType: self.filterStore.lessonType,
      });
    }
    const changeSplitSchedule = flow(function* changeSplitSchedule(
      splitIndex,
      days = [],
    ) {
      if (days.length > 0) {
        self.splitRequests = cast(
          self.splitRequests.map((split, index) => {
            if (index === splitIndex) {
              return { ...getSnapshot(split), lessonDays: days };
            }
            return getSnapshot(split);
          }),
        );
      }
    });
    const newSplitUpdateBySchedule = () => {
      let currentSplits = self.useRequestDataProps.getScheduleSplit(
        getSnapshot(self.splitRequests),
      );
      self.splitRequests = cast(currentSplits);
    };
    const updateRequestInfo = flow(function* updateRequestInfo(
      withSplit = true,
    ) {
      try {
        yield self.useRequestDataProps.saveRequestToServer(
          self.isAdminLogin,
          // self.requestData.slug,
          withSplit ? self.requestData.splitRequests : undefined,
        ); // should have updated the main request
        if (withSplit) {
        }
        self.useRequestDataProps.moveToNewScheduleFlow();
        newSplitUpdateBySchedule();
      } catch (error) {
        throw error;
      }
    });
    const initializeProfileToClient = flow(function* init(
      { coupon = "", firstSearch, tutors, requestInfo, specialities = [] },
      currencyForCountry?: string,
    ) {
      if (currencyForCountry) {
        self.oldSearchContextProps.updateCurrency(currencyForCountry);
      }
      self.displaySelectedTutors = true;
      yield initializeApplication(
        requestInfo,
        coupon,
        firstSearch,
        tutors,
        specialities,
      );
      // debugger;
    });
    const initializeBookingData = flow(function* initBooking({
      requestInfo,
      tutors = [],
      bookingInfo,
      agent,
    }) {
      yield initializeApplication(requestInfo, "", tutors, tutors, []);
      self.bookingInfo = BookingStore.create(bookingInfo);
      // bookingStore.initializeRequestData(ACADEMICS_DATA).then(() => {
      //   bookingStore.getBookingInfo("XAB101"); // or use bookingStore.updateBookingInfo with raw data
      // });
      self.useRequestDataProps.updateServerInfo({
        agent,
        created: requestInfo.created,
        modified: requestInfo.modified,
        status: requestInfo.status,
      });
      self.displaySelectedTutors = true;
      // self.useRequestDataProps.updateLoggedIn(true)
    });
    const initializeClientRequest = flow(function* initializeClientR({
      tutorResponses,
      pricingInfo,
      requestInfo,
      tutors = [],
      bookingInfo,
      agent,
    }) {
      yield initializeBookingData({ requestInfo, tutors, bookingInfo });
      self.clientRequest.mapToStore({ tutorResponses, pricingInfo });
    });
    const initializeLessonDetailPage = flow(
      function* initializeLessonDetailPage({
        regions,
        countries,
        requestInfo,
        academicData,
      }) {
        yield initializeRequestStore(requestInfo, [], [], academicData);
        adapter.updateStaticData({ regions, countries, requestInfo });
        self.useRequestDataProps.lessonLocationStore.updateFields({
          regions,
          countries,
        });
        // yield self.useRequestDataProps.initializeRequestData(
        //   academicData,
        //   true
        // );
      },
    );
    return {
      initializeLessonDetailPage,
      initializeClientRequest,
      initializeBookingData,
      initializeProfileToClient,
      fetchTutor,
      saveRequestInfo,
      newSplitUpdateBySchedule,
      updateRequestInfo,
      onSubmit,
      initializeApplication,
      initializeRequestStore,
      // afterCreate() {
      //   initializeApplication("");
      // },
      onCreate() {
        return self.oldSearchContextProps.onCreate();
      },
      setDeniedTutors(deniedTutors) {
        self.deniedTutors = deniedTutors;
      },
      initializeSearch() {
        return self.oldSearchContextProps.initializeSearch();
      },
      changeTutorHourlyRate(tutorId, newRate) {
        let tutorInstance = self.splitRequests.find(
          (o) => o.tutorId === tutorId,
        );
        if (tutorInstance) {
          tutorInstance.setNewRate(newRate);
        }
      },
      determineTotalTuition(tutorId, hourlyRate = 0) {
        return self.oldSearchContextProps.determineTotalTuition(
          tutorId,
          hourlyRate,
        );
      },

      updateSplitRequests,
      updateSelectedTutors(data, index, skip = false) {
        self.useRequestDataProps.updateSelectedTutors(data, index);
        let selectedTutors = self.useRequestDataProps.selectedTutors;
        let splitRequests = self.splitRequests.map((o, i) => {
          // let tt = selectedTutors[i];
          if (i === index) {
            // if (i === index && tt) {
            if (data.userId !== o.tutorId) {
              return {
                ...getSnapshot(o),
                tutorData: data,
                // tutorData: getSnapshot(data),
                tutorId: data.userId,
              };
            }
          }
          return getSnapshot(o);
        });
        self.splitRequests = cast(splitRequests);
        // updateSplitRequests();
        // self.splitRequests = cast(
        //   self.splitRequests.map((o, i) => {
        //     if (i === index) {
        //       return {
        //         ...getSnapshot(o),
        //         tutorData: data,
        //         tutorId: data.userId,
        //       };
        //     }
        //     return getSnapshot(o);
        //   })
        // );
        // self.selectedTutors.splice(index, 1, data);
      },
      onUpdateFilters,
      removeSelectedTutor(index) {
        self.useRequestDataProps.removeSelectedTutor(index);
        updateSplitRequests();
        // self.splitRequests = cast(
        //   self.splitRequests.map((o, i) => {
        //     if (i === index) {
        //       return { ...getSnapshot(o), tutorData: null, tutorId: null };
        //     }
        //     return getSnapshot(o);
        //   })
        // );
      },
      sendSearchLink() {
        let data = self.requestData;
        let paymentInfo = self.oldSearchContextProps.generatePaymentInfo();
        return self.useRequestDataProps.sendSearchLink(data, paymentInfo);
      },
      sendRequestToClient() {
        return self.useRequestDataProps.sendRequestToClient();
      },
      toggleClientNotification() {
        self.notifyClient = true;
      },
      setFareData(farePerKM, distancePerThreshold) {
        self.farePerKM = farePerKM;
        self.distanceThreshold = distancePerThreshold;
      },
    };
  });
// make splitRequests anstpre actual field instead of a view.
